import React from "react";
import { ArrowRight, CheckCircle, Circle } from "lucide-react";

const Hero: React.FC = () => {
  const video = document.querySelector('video');
  if (video) {
    video.playbackRate = 0.8;
  }
  return (
    <section
      className="relative  text-white py-16 sm:py-20 lg:py-24 overflow-hidden"
      style={{ background: "#07050F" }}
      role="banner"
      aria-label="Hero section with company value proposition"
    >
      {/* Video Background */}
      <div className="absolute inset-0 lg:left-1/2 lg:w-1/2">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-contain opacity-80"
          style={{scale: "0.8"}}
          aria-hidden="true"
        >
          <source src="/atomic-animation_resized.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          className="absolute inset-0 bg-gradient-to-l from-transparent via-gray-900/20 to-gray-900/80"
          style={{ background: "transparent" }}
        ></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left relative z-10">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6">
              Transform Regulatory
              <span className="block text-yellow-300">Compliance Costs</span>
              Into Competitive Advantage
            </h1>

            {/* <p className="text-lg sm:text-xl lg:text-2xl mb-8 text-gray-300 leading-relaxed">
              We turn fixed regulatory reporting costs into variable, predictable
              expenses while future-proofing against regulatory changes.
            </p> */}

            {/* Key Benefits */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">Regulatory Computation</span>
              </div>
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">
                  Regulatory Reporting
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">
                  Fund Data Management
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">Risk Management Consulting</span>
              </div>
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">Managed Services</span>
              </div>
              <div className="flex items-center space-x-3">
                <Circle className="h-5 w-5 text-green-400 flex-shrink-0" />
                <span className="text-sm lg:text-base">API Services</span>
              </div>
            </div>
          </div>

          {/* Right side spacer for video */}
          <div className="hidden lg:block"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
